import React, { Component } from "react";

// Material-UI
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

// Internal
import ChatHeader from "./ChatHeader";
import ChatFooter from "./ChatFooter";
import ChatMessageFeed from "./ChatMessageFeed";
import MinimizeContextProvider from "../../../device/components/context/MinimizeContext";
import Device from "sccDevice";
import DeviceOverlay from "sccDeviceOverlay";
import _, { parseInt } from "lodash";
import Message from "../../../message/scripts/Message";
import Chat from "sccChat";
import { Badge } from "@material-ui/core";

export default class ChatOverlay extends Component {
  constructor() {
    super();
    this.state = {
      1: { minimize: true, hidden: true, data: null },
      // 2: { minimize: true, hidden: true, data: null },
      // 3: { minimize: true, hidden: true, data: null },
    };

    if (!ChatOverlay.publicInstance) {
      ChatOverlay.publicInstance = this;
    }
  }

  static publicInstance;
// checks if chat is open in order to make multichat work && not send messages to the wrong device in multichat
  checkIfChatIsOpenForDevice(deviceId) {
    var chatIsOpen = false;
    var chatWindowsOpen = _.map(this.state)
    chatWindowsOpen.forEach(chatWindowsOpen => { 
      if (chatWindowsOpen.data?.id == deviceId && chatWindowsOpen.hidden == false )
      {
        chatIsOpen = true;
        return;
      }
      if (chatIsOpen)
      {return;}
    });
    
    return chatIsOpen;
  }

  static updateFeatureSelected() {
    setTimeout(() => {
      ChatOverlay.publicInstance.setFeatureSelected();
    });
  }

  static hideChatWindow(closingDevice) {
    setTimeout(() => {
      ChatOverlay.publicInstance.close(closingDevice);
    });
  }

  static minimizeChatWindow(minimizingDevice) {
    setTimeout(() => {
      ChatOverlay.publicInstance.hide(minimizingDevice);
    });
  }

  static maximizeChatWindowForId(showingDeviceId) {
    setTimeout(() => {
      Chat.asyncLoadMessageChat(showingDeviceId).then(() => {
        const showingDevice = Device.get(showingDeviceId);
        ChatOverlay.publicInstance.show(showingDevice);
      });
    });
  }

  static maximizeChatWindow(showingDevice) {
    setTimeout(() => {
      ChatOverlay.publicInstance.show(showingDevice);
    });
  }

  // close function that will check the device position in the object and will shift them to an empty position leaving any free space to the end
  close(closingDevice) {
    this.setState((prevState) => {
      const foundkey = _.findKey(this.state, (devices) => {
        return _.isEqual(devices.data, closingDevice);
      });
      if (foundkey) {
        const updateState = { ...prevState };
        updateState[foundkey] = { minimize: true, hidden: true, data: null };
        for (
          let prevKey = 1;
          prevKey < Object.keys(updateState).length;
          prevKey++
        ) {
          const nextKey = prevKey + 1;
          if (updateState[prevKey].data === null) {
            updateState[prevKey] = updateState[nextKey];
            updateState[nextKey] = { minimize: true, hidden: true, data: null };
          }
        }
        return updateState;
      }
      return prevState;
    });
  }

  hide(minimizingDevice) {
    this.setState((prevState) => {
      const foundkey = _.findKey(this.state, (devices) => {
        return _.isEqual(devices.data, minimizingDevice);
      });
      if (foundkey) {
        const updateState = { ...prevState };
        updateState[foundkey] = {
          minimize: true,
          hidden: prevState[foundkey].hidden,
          data: prevState[foundkey].data
        };

        return updateState;
      }
      return prevState;
    });
  }

  show(showingDevice) {
    if (this.state[1].hidden == false && this.state[1].data !== showingDevice) {
      //this.setState[1].hidden == true
      this.close(this.state[1].data)
    }
    this.setState((prevState) => {
      const foundkey = _.findKey(this.state, (devices) => {
        return _.isEqual(devices.data, showingDevice);
      });
      if (foundkey) {
        //const updateState = { ...prevState };
        const updateState = {  };
        updateState[foundkey] = {
          minimize: false,
          hidden: prevState[foundkey].hidden,
          data: prevState[foundkey].data,
        };
        // for (let key = 1; key < 4; key++) {
        //   if (key !== parseInt(foundkey))
        //     updateState[key] = {
        //       minimize: true,
        //       hidden: prevState[key].hidden,
        //       data: prevState[key].data,
        //     };
        // }

        return updateState;
      }
      return prevState;
    });
  }

  setFeatureSelected() {
    if (DeviceOverlay.getSelectedId()) {
      let tempDevice = Device.get(DeviceOverlay.getSelectedId());
      const foundkey = _.find(this.state, (devices) => {
        return _.isEqual(devices.data, tempDevice);
      });

      if (!Boolean(foundkey)) {
        this.setState((prevState) => {
          if (prevState[1].data === null) {
            return {
              1: { minimize: false, hidden: false, data: tempDevice },
            };
          }// else if (prevState[2].data === null) {
          //   return {
          //     2: { minimize: true, hidden: false, data: tempDevice },
          //   };
          // } else if (prevState[3].data === null) {
          //   return {
          //     3: { minimize: true, hidden: false, data: tempDevice },
          //   };
          // }
        });
      }
    }
  }

  render() {
    const device = this.state;
    const chatBoxWidth = 300;
    

    const gridStyle = {
      position: "fixed",
      bottom: "25px",
      left: "5px",
      zIndex: "1000",
      width: `${chatBoxWidth}px`,
    };
    const chatBoxStyle = {
      width: `${chatBoxWidth}px`,
      zIndex: "200",
      backgroundColor: "white",
      color: "black",
    };

    return (
      <MinimizeContextProvider>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-end"
          style={gridStyle}
        >
          {device[1]?.data ? (
            <Grid item xs="auto">
              <Paper
                className={"ChatOverlay"}
                elevation={3}
                id={"olMapChatPopup"}
                style={chatBoxStyle}
              >
                {device[1].data && !device[1].hidden ? (
                  <React.Fragment>
                    <ChatHeader
                      device={device[1].data}
                      minimize={device[1].minimize}
                    />
                    {!device[1].minimize ? (
                      <ChatMessageFeed  device={device[1].data} />
                    ) : (
                      ""
                    )}
                    {!device[1].minimize ? (
                      <ChatFooter device={device[1].data} />
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : null}
              </Paper>
            </Grid>
          ) : null}

                  
        </Grid>
      </MinimizeContextProvider>
    );
  }
}
